import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SAPDOCUMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.SapDocumentType.Name')
    .required()
    .build(),
  FieldBuilder.text('code', 'Entity.SapDocumentType.Code')
    .build(),
  FieldBuilder.text('saps4Code', 'Entity.SapDocumentType.SapS4Code')
    .build(),
];

export const SAPDOCUMENTTYPE_CONFIG = {
  entityName: 'SapDocumentType',
  localizationKey: 'Controlling::Entity.SapDocumentType',
  fields: SAPDOCUMENTTYPE_FIELDS,
  permission: 'ControllingSap.SapDocumentTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
